// URL <-> state of the owner dashboard. The state is the shared filters (period, dates, vehicle, chart granularity): the URL is the
// single source of truth, so a view can be shared or reloaded. Pure functions (no browser, no React). Nothing here computes an amount.

import {
  DEFAULT_FILTERS, parseFilters, addFilterParams, normalizeFilters,
} from '../shared/reportingFilters';

export const DASHBOARD_PATH = '/owner/dashboard';
export const EARNINGS_PATH = '/owner/earnings';
export const VEHICLES_PATH = '/cars';
export const RESERVATIONS_PATH = '/reservation/current';
export const ADD_VEHICLE_PATH = '/become-a-owner';

export const parseDashboardQuery = (input) => parseFilters(input);

export function buildDashboardPath(state) {
  const query = addFilterParams(new URLSearchParams(), state).toString();
  return query ? `${DASHBOARD_PATH}?${query}` : DASHBOARD_PATH;
}

// A filter change = a new state (dates only for a custom period).
export const applyDashboardPatch = (state, patch) => normalizeFilters({ ...DEFAULT_FILTERS, ...state, ...patch });

// "See my payouts": the revenue page opened with the same period, dates and vehicle (and chart grouping).
export function buildEarningsLink(state) {
  const query = addFilterParams(new URLSearchParams(), state).toString();
  return query ? `${EARNINGS_PATH}?${query}` : EARNINGS_PATH;
}

export const listingPath = (listId) => `/cars/${listId}`;

// Variables of the getOwnerDashboard query for a state.
export function buildDashboardVariables(state, convertCurrency) {
  const variables = { period: state.period, granularity: state.granularity };
  if (state.period === 'custom') { variables.startDate = state.startDate; variables.endDate = state.endDate; }
  if (state.listId) variables.listId = state.listId;
  if (convertCurrency) variables.convertCurrency = convertCurrency;
  return variables;
}

// True when the server reports something for the period (no amount is computed: values are only tested against zero).
export function hasActivity(dashboard) {
  const indicators = (dashboard && dashboard.indicators) || {};
  const value = (indicator) => Number(indicator && indicator.value) || 0;
  return ((dashboard && dashboard.recentActivity) || []).length > 0
    || value(indicators.netRevenue) !== 0 || value(indicators.volume) !== 0 || value(indicators.bookings) > 0
    || value(indicators.rentedDays) > 0 || value(indicators.cancellations) > 0;
}

// Which screen to show. Pure so the screens can be tested without Apollo.
// notLoggedIn: anonymous / administrator ; error: network error or status 'failed' ; loading: first load (no earlier data) ;
// empty: no vehicle at all (invite to add one) or no activity ; noResults: the vehicle filter leaves nothing ; data.
export function deriveDashboardView({ loading, networkError, dashboard, state }) {
  if (dashboard && dashboard.status === 'notLoggedIn') return 'notLoggedIn';
  if (dashboard && dashboard.status === 'failed') return 'error';
  if (!dashboard) return networkError ? 'error' : (loading ? 'loading' : 'error');
  if (hasActivity(dashboard)) return 'data';
  return state.listId ? 'noResults' : 'empty';
}
